import { createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2f95f493")

_pushScopeId("data-v-2f95f493")
const _hoisted_1 = /*#__PURE__*/_createVNode("h3", null, "問診追加", -1)
const _hoisted_2 = { class: "date-information-row" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "information-title" }, "問診：", -1)
const _hoisted_4 = { class: "button-frame" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("お客様が")
const _hoisted_6 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("自分の端末で入力 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("この端末で入力 ")
const _hoisted_9 = { class: "button-frame" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("閉じる ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_list_box = _resolveComponent("list-box")
  const _component_normal_button = _resolveComponent("normal-button")
  const _component_white_backdrop = _resolveComponent("white-backdrop")

  return (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
    _createVNode(_component_white_backdrop, { show: _ctx.show }, {
      default: _withId(() => [
        _withDirectives(_createVNode("div", {
          class: ["frame", _ctx.$mq]
        }, [
          _hoisted_1,
          _createVNode("div", _hoisted_2, [
            _hoisted_3,
            _createVNode(_component_list_box, {
              class: "inquiry-list",
              title: "問診",
              items: _ctx.inquiryListItems,
              modelValue: _ctx.selectedInquiryId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedInquiryId = $event)),
              size: Math.min(6, _ctx.inquiryListItems.length)
            }, null, 8, ["items", "modelValue", "size"])
          ]),
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_normal_button, {
              type: "button",
              class: "button",
              state: "warning",
              onClick: _ctx.dismiss
            }, {
              default: _withId(() => [
                _hoisted_5,
                _hoisted_6,
                _hoisted_7
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_normal_button, {
              type: "button",
              class: "button",
              state: "normal",
              onClick: _ctx.dismiss
            }, {
              default: _withId(() => [
                _hoisted_8
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode(_component_normal_button, {
              type: "button",
              class: "close-button",
              state: "confirm",
              onClick: _ctx.dismiss
            }, {
              default: _withId(() => [
                _hoisted_10
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ], 2), [
          [_vShow, _ctx.show]
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
})